import apiClient from './api.service';

export const manufacturingDashboardService = {
  /**
   * Get production overview
   * @param date - Optional date string (YYYY-MM-DD)
   */
  getOverview: (date?: string) =>
    apiClient.get('/manufacturing/dashboard/overview', { params: { date } }),

  /**
   * Get KPI metrics
   * @param period - Time period: today, week, or month
   */
  getKPIs: (period: 'today' | 'week' | 'month' = 'today') =>
    apiClient.get('/manufacturing/dashboard/kpis', { params: { period } }),

  /**
   * Get production trends
   * @param days - Number of days to retrieve (1-90)
   */
  getTrends: (days: number = 7) =>
    apiClient.get('/manufacturing/dashboard/trends', { params: { days } }),

  /**
   * Get workstation status
   */
  getWorkstations: () =>
    apiClient.get('/manufacturing/dashboard/workstations'),

  /**
   * Get schedule overview for Gantt chart
   * @param startDate - Start date (YYYY-MM-DD)
   * @param endDate - End date (YYYY-MM-DD)
   */
  getSchedule: (startDate: string, endDate: string) =>
    apiClient.get('/manufacturing/dashboard/schedule', { 
      params: { startDate, endDate } 
    }),

  /**
   * Get quality metrics
   * @param period - Time period: today, week, or month
   */
  getQuality: (period: 'today' | 'week' | 'month' = 'today') =>
    apiClient.get('/manufacturing/dashboard/quality', { params: { period } }),

  /**
   * Get resource tracking (operators and materials)
   */
  getResources: () =>
    apiClient.get('/manufacturing/dashboard/resources'),

  /**
   * Get alerts and notifications
   */
  getAlerts: () =>
    apiClient.get('/manufacturing/dashboard/alerts'),
};

export default manufacturingDashboardService;
